import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";

import $ from "jquery";

//components
import { ViewportProvider } from "./ViewportProvider";
import { DataProvider } from "./DataContext";
import Map from "./components/map/Map";
import ResultsModule from "./components/ResultsModule";

const App = () => {
  const [currentLocation, setCurrentLocation] = useState(null);
  const [visibleMarkers, setVisibleMarker] = useState([]);
  const [nationalMarkers, setNationalMarker] = useState([]);
  const [placesLoaded, setPlacesLoaded] = useState();
  const [mobileView, setMobileView] = useState();
  const [currentView, setCurrentView] = useState({
    initialView: true,
    mapView: false,
    filterView: false,
    searchView: false,
    expandView: false,
    modalView: false
  });
  const [markerMap, setMarkerMap] = useState([]);
  const [selectedResult, setSelectedResult] = useState({
    id: 0,
    mapClick: false
  });
  const [togglePinsOff, setTogglePinsOff] = useState(false);
  const searchRef = useRef();
  const mapRef = useRef();
  const [currentSearchValue, setCurrentSearchValue] = useState();
  const [selectedPinData, setSelectedPinData] = useState();

  //const [initialLoad, setInitialLoad] = useState(false);

  const handleSetMapRef = map => {
    mapRef.current = map;
  };

  const handleSetCurrentView = view => {
    //console.log(view);
    switch (view) {
      case "initialView":
        setCurrentView({
          initialView: true,
          mapView: false,
          filterView: false,
          searchView: false,
          expandView: false,
          modalView: false,
          detailsView: false
        });
        break;
      case "mapView":
        setCurrentView({
          initialView: false,
          mapView: true,
          filterView: false,
          searchView: false,
          expandView: false,
          modalView: false,
          detailsView: false
        });
        break;
      case "filterView":
        setCurrentView({
          initialView: false,
          mapView: false,
          filterView: true,
          searchView: false,
          expandView: false,
          modalView: false,
          detailsView: false
        });
        break;
      case "searchView":
        setCurrentView({
          initialView: false,
          mapView: false,
          filterView: false,
          searchView: true,
          expandView: false,
          modalView: false,
          detailsView: false
        });
        break;
      case "expandView":
        setCurrentView({
          initialView: false,
          mapView: false,
          filterView: false,
          searchView: false,
          expandView: true,
          modalView: false,
          detailsView: false
        });
        break;
      case "modalView":
        setCurrentView({
          initialView: false,
          mapView: false,
          filterView: false,
          searchView: false,
          expandView: false,
          modalView: true,
          detailsView: false
        });
        break;
      case "detailsView":
        setCurrentView({
          initialView: false,
          mapView: false,
          filterView: false,
          searchView: false,
          expandView: false,
          modalView: false,
          detailsView: true
        });
        break;
    }
  };

  const handleSetCurrentLocation = location => {
    setCurrentLocation(location);
  };

  const handleSetCurrentMarker = (id, mapClick) => {
    setSelectedResult({ id: id, mapClick: mapClick });

    ////set data for pin
    let selectedPinData = [];

    markerMap.map(
      (marker, index) => {
        if (id - 1 === index) {
          selectedPinData.push([marker[0], marker[1]]);
        }
      },
      [
        setTimeout(function() {
          setSelectedPinData(selectedPinData);
        }, 500)
      ]
    );
    ///

    if (currentView.initialView) {
      handleSetCurrentView("searchView");
      //handleSearchUpdate();
    }
  };

  const handleSetPlaces = () => {
    setPlacesLoaded(true);
  };

  const handleMarkerData = data => {
    setMarkerMap(data);
    //setSelectedPinData(data);
  };

  const handleVisibleMarkers = visibleMarkers => {
    setVisibleMarker(visibleMarkers);
  };

  const handleNationalMarkers = markers => {
    //has filtered out national marker if in visible marker array
    setNationalMarker(markers);
  };

  const handleSearchUpdate = () => {
    setTimeout(function() {
      searchRef.current.getViewableMarkers();
      setSelectedResult({ id: 0, mapClick: false });
    }, 1000);
  };

  const handleTogglePins = () => {
    //uncheck markers called from search module
    //console.log("handleTogglePins");
    setTogglePinsOff(true);
    setSelectedResult({ id: 0, mapClick: false });
    setTimeout(function() {
      setTogglePinsOff(false);
    }, 100);
  };

  const updateMobileView = isMobile => {
    setMobileView(isMobile);
  };

  const handleCurrentSearchValue = value => {
    setCurrentSearchValue(value);
  };

  useEffect(() => {
    //clear states
    $(".resultsModule").css({ "padding-top": "0px" });
    $(".mapModule").show();
    $(".mapControls").show();

    //

    if (currentView.initialView) {
      $(".mapControls").show("fast");
      $(".mapModule").show("fast");
      $(".resultsModule").hide("fast");
      $(".mapModule").animate({
        width: "100%"
      });
    }

    if (currentView.mapView) {
      $(".mapControls").show("fast");
      $(".mapModule").show("fast");
      $(".resultsModule").removeClass("expandView");
      if (mobileView) {
        $(".displayItems").hide("fast");
        $(".mapModule").animate({
          height: "600px"
        });
      }
    }
    if (currentView.filterView) {
      $(".resultsModule").show("fast");
      $(".filterResults").css({ display: "flex" });
      $(".searchResults").hide("fast");
      $(".displayItems").show("fast");
      if (mobileView) {
        $(".mapModule").animate({
          height: "0px"
        });
        $(".resultsModule").css({ "padding-top": "80px" });
        $(".mapControls").hide("fast");
      }
    }
    if (currentView.searchView) {
      $(".resultsModule").show("fast");
      $(".filterResults").hide("fast");
      $(".searchResults").show("fast");
      $(".resultsContainer").show("fast");

      setTimeout(function() {
        $(".noResultTxt").show("slow");
      }, 1000);

      $(".mapModule").show("fast");
      $(".resultsModule").removeClass("expandView");
      if (mobileView) {
        $(".mapModule").animate({
          height: "400px"
        });
        $(".resultsModule").show("fast");
      }
      if (!mobileView) {
        $(".mapSearchField").hide("fast");
        $(".mapModule").animate({
          width: "70%"
        });
      }
    }
    if (currentView.detailsView) {
      $(".resultsModule").show("fast");
      $(".filterResults").hide("fast");
      $(".resultsContainer").hide("fast");
      $(".searchResults").show("fast");
      $(".noResultTxt").hide("fast");
      $(".mapModule").show("fast");
      $(".resultsModule").removeClass("expandView");
    }
    if (currentView.modalView) {
      $(".mapModule").hide("fast");
    }
    if (currentView.expandView) {
      $(".displayItems").show("fast");
      if (mobileView) {
        $(".filterResults").hide("fast");
        $(".mapModule").show("fast");
        $(".resultsModule").show("fast");
        $(".searchResults").show("fast");
        $(".mapModule").animate({
          height: "400px"
        });
        setTimeout(function() {
          $(".noResultTxt").show("slow");
        }, 1000);
      } else {
        $(".mapModule").hide("fast");
        $(".resultsModule").addClass("expandView");
        $(".resultsModule").show("fast");
        $(".filterResults").show("fast");
        $(".searchResults").show("fast");
      }
    }
  }, [currentView]);

  useEffect(() => {
    if (currentView.modal) {
      $(".searchList").hide("fast");
    } else {
      $(".searchList").show("fast");
    }
  }, [currentView]);

  return (
    <ViewportProvider>
      <DataProvider>
        <div id="app">
          <Map
            setMapRef={handleSetMapRef}
            setPlaces={handleSetPlaces}
            passVisibleMarkers={handleVisibleMarkers}
            passNationalMarkers={handleNationalMarkers}
            currentView={currentView}
            passMarkerData={handleMarkerData}
            updateCurrentView={handleSetCurrentView}
            updateCurrentLocation={handleSetCurrentLocation}
            currentLocation={currentLocation}
            searchRef={searchRef}
            setSelectedMarker={handleSetCurrentMarker}
            togglePinsOff={togglePinsOff}
            mobileView={mobileView}
            selectedResult={selectedResult}
            currentSearchValue={handleCurrentSearchValue}
          />
          {placesLoaded ? (
            <ResultsModule
              mapRef={mapRef}
              searchUpdate={handleSearchUpdate}
              visibleMarkers={visibleMarkers}
              nationalMarkers={nationalMarkers}
              currentView={currentView}
              updateCurrentView={handleSetCurrentView}
              currentLocation={currentLocation}
              markerMap={markerMap}
              selectedResult={selectedResult}
              updateMobileView={updateMobileView}
              togglePinsOff={handleTogglePins}
              setSelectedMarker={handleSetCurrentMarker}
              currentSearchValue={currentSearchValue}
              selectedPinData={selectedPinData}
            />
          ) : null}
        </div>
      </DataProvider>
    </ViewportProvider>
  );
};

ReactDOM.render(<App />, document.getElementById("root"));
